import { useEffect, useState } from 'react';

export default function AboutHero() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 60);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-[72vh] flex items-center overflow-hidden bg-zinc-950 pt-24 pb-16">
      {/* Background glows */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div
          className="absolute -top-32 left-1/4 w-[600px] h-[600px] rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(249,115,22,0.10) 0%, transparent 65%)' }}
        />
        <div
          className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(251,191,36,0.06) 0%, transparent 65%)' }}
        />
        <div
          className="absolute inset-0 opacity-[0.025]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(249,115,22,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(249,115,22,0.6) 1px, transparent 1px)',
            backgroundSize: '64px 64px',
          }}
        />
        <div className="absolute bottom-0 inset-x-0 h-40 bg-gradient-to-t from-zinc-950 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-3xl">
          {/* Badge */}
          <div
            className="inline-flex items-center gap-2 bg-zinc-900/80 border border-orange-500/20 rounded-full px-4 py-1.5 mb-8"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(10px)',
              transition: 'opacity 0.5s ease, transform 0.5s ease',
            }}
          >
            <i className="ri-user-line text-orange-400 text-sm" />
            <span className="text-orange-300 text-sm font-medium">Môj príbeh</span>
          </div>

          <h1
            className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[1.02] tracking-tight mb-6"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 0.65s ease, transform 0.65s ease',
              transitionDelay: '0.1s',
            }}
          >
            Za každým projektom
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">
              stojím osobne.
            </span>
          </h1>

          <p
            className="text-zinc-400 text-lg md:text-xl leading-relaxed max-w-2xl"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(12px)',
              transition: 'opacity 0.65s ease, transform 0.65s ease',
              transitionDelay: '0.22s',
            }}
          >
            Boostio som ja - Kamil Frajtko. 15+ rokov v IT mi dalo prehľad, ktorý väčšina agentúr jednoducho nemá.
            Weby, e-shopy, CRM systémy, automatizácie - viem čo robím a výsledok vždy odzrkadľuje moje meno.
          </p>
        </div>

        {/* Quick stats row */}
        <div
          className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
            transitionDelay: '0.38s',
          }}
        >
          {[
            { value: '15+', label: 'Rokov v IT' },
            { value: '50+', label: 'Spokojných klientov' },
            { value: '80+', label: 'Dokončených projektov' },
            { value: 'Prešov', label: 'Slovensko' },
          ].map((s) => (
            <div key={s.label} className="bg-zinc-900/50 border border-zinc-800/50 rounded-2xl px-6 py-5">
              <p className="text-3xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-br from-white to-zinc-400 mb-1">
                {s.value}
              </p>
              <p className="text-zinc-500 text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
